import { hub } from './hub-client';

export interface BootstrapStatus {
  enabled: boolean;
  hasAdmin: boolean;
}

let cached: Promise<BootstrapStatus> | null = null;

/**
 * Fetch the bootstrap status once per page load. The SPA branches on this:
 *   - enabled && !hasAdmin → render the bootstrap-admin form on first visit
 *   - otherwise            → ordinary login flow, hide the bootstrap link
 */
export function getBootstrapStatus(): Promise<BootstrapStatus> {
  if (cached) return cached;
  const fallback: BootstrapStatus = { enabled: false, hasAdmin: true };
  const next: Promise<BootstrapStatus> = hub
    .authBootstrapStatus()
    .then((r): BootstrapStatus => ({ enabled: r.enabled, hasAdmin: r.hasAdmin }))
    .catch(() => fallback);
  cached = next;
  return next;
}
